import { defineMessages } from 'react-intl';
const ID_PREFIX = 'WacSignupForm.';
export const messages = defineMessages({
  devopsSwitchAccounts: {
    id: `${ID_PREFIX}devopsSwitchAccounts`,
    defaultMessage: 'Log in to another account'
  },
  devopsEarlyAccess: {
    id: `${ID_PREFIX}devopsEarlyAccess`,
    defaultMessage: 'EARLY ACCESS PROGRAM'
  },
  devopsLogoSubHeader: {
    id: `${ID_PREFIX}devopsLogoSubHeader`,
    defaultMessage: "DevOps isn't bought, it's built"
  },
  devopsLogo: {
    id: `${ID_PREFIX}devopsLogo`,
    defaultMessage: 'solution'
  }
});
